import * as React from "react"
import { ProductOptionProps } from "./types"
import { Flex, Text, useRadioGroup } from "@chakra-ui/react"
import { ProductOptionButton } from "./product-option-button"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"

const _ProductOption: React.FC<ProductOptionProps> = ({
  option,
  selectedOption,
  onChange,
  handleUnselectProductOption,
  isButtonGroup,
  checkProductOptionExist
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { getRootProps, getRadioProps, setValue } = useRadioGroup({
    name: option.name,
    value: selectedOption?.value,
    onChange: nextValue => {
      /*  if (isButtonGroup && value === nextValue) {
        handleUnselectProductOption({
          name: option.name,
          value: nextValue,
          option_id: option.id
        })
      } else { */
      onChange({
        name: option.name,
        value: nextValue,
        option_id: option.id
      })
    }
  })

  React.useEffect(() => {
    setValue(selectedOption?.value)
  }, [selectedOption?.value, setValue])

  const group = getRootProps()

  return (
    <Flex flexDirection="column" width="max-content">
      <Text
        opacity={0.75}
        fontSize={"0.7rem"}
        marginTop="0.3rem"
        color={roomStyles?.badgeTextColor && roomStyles?.badgeTextColor}
        fontFamily={roomStyles?.badgeFontFamily ?? "Assistant, sans-serif"}
      >
        {option.name}
      </Text>
      <Flex {...group} overflow="hidden" ps="1" width="max-content">
        {option.values.map(value => {
          const radio = getRadioProps({ value })
          return (
            <ProductOptionButton
              key={value}
              {...radio}
              isSmallMainScreen={/* isSmallMainScreen */ false}
              isMobile={/* isMobile */ false}
              isDisabled={!checkProductOptionExist(value)}
            >
              {value}
            </ProductOptionButton>
          )
        })}
      </Flex>
    </Flex>
  )
}

export const ProductOption = React.memo(_ProductOption)
